"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadDataSet = downloadDataSet;
const baseUrls_1 = require("./baseUrls");
const fetchWrapper_1 = require("./fetchWrapper");
async function downloadDataSet(authHeader, datasetName, gigId) {
    const url = `${baseUrls_1.UploadsApiBaseUrl}/${datasetName}Download?gigId=${gigId}`;
    return (0, fetchWrapper_1.fetchWrapper)(url, {
        method: 'GET',
        headers: {
            Authorization: authHeader,
        },
    });
}
